import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AddCreditForUserComponent from "../../../components/Admin/users/AddCreditForUserComponent";

const AddCreditForUserPage = () => {
    const params = useParams()
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/admin/khach-hang');
    }

    let redirectBack = () => {
        navigate('/admin/khach-hang/chi-tiet-khach-hang/' + params.userId);
    }

    return <AddCreditForUserComponent
        userId={ params.userId }
        shouldRedirect={ () => redirect() }
        redirectBack={ () => redirectBack() }
    />;
}

export default AddCreditForUserPage;